<template>
  <RevDrawer :name :title>
    <template #body>
      <div class="mb-32">
        <RevIllustration
          alt=""
          class="w-full"
          :height="137"
          src="/img/reassurance/warranty-modal.svg"
          :width="327"
        />
      </div>
      <WarrantyModalContent :warranty-location>
        <WarrantyExclusion />
      </WarrantyModalContent>
    </template>
  </RevDrawer>
</template>

<script lang="ts" setup>
import { computed } from 'vue'

import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { useMarketplace } from '@backmarket/nuxt-module-marketplace/useMarketplace'
import { RevDrawer } from '@ds/components/Drawer'
import { RevIllustration } from '@ds/components/Illustration'

import {
  CMS,
  LEGAL_PAGE_NAME,
} from '../WarrantyExclusion/WarrantyExclusion.constant'
import WarrantyExclusion from '../WarrantyExclusion/WarrantyExclusion.vue'
import WarrantyModalContent from '../WarrantyModalContent/WarrantyModalContent.vue'

import translations from './WarrantyModal.translations'

defineProps<{
  name: string
}>()

const i18n = useI18n()
const { features } = useMarketplace()

const title = computed(() => {
  return i18n(translations.title, {
    warrantyDuration: features.warranty.duration,
  })
})

const warrantyLocation = {
  name: CMS.LEGAL_PAGE,
  params: {
    pageName: LEGAL_PAGE_NAME.WARRANTY,
  },
}
</script>
